export default "__VITE_ASSET__C9fWyK_5__"